import axiosConfig from '../axiosConfig';
import { LambdaInsightsRequest, LambdaInsightsResponse, GenericResponse } from '../types';
import {
	LambdaDashboardSummaryRequest,
	LambdaGraphSummariesRequest,
} from '../types/lambda-graph-summaries-request';
import {
	LambdaDashboardSummaryResponse,
	LambdaGraphSummariesResponse,
} from '../types/lambda-graph-summaries-response';

export class Lambda {
	public static GetInsights(
		request: LambdaInsightsRequest,
		isDashboardInsights = false
	): Promise<GenericResponse<LambdaInsightsResponse>> {
		let url = 'app/lambda';

		if (isDashboardInsights) {
			url += '?isDashboardInsights=true';
		}
		return axiosConfig.instance.post(url, request).then((res) => {
			return res.data as GenericResponse<LambdaInsightsResponse>;
		});
	}

	public static GetGraphSummariesInsights(
		request: LambdaGraphSummariesRequest
	): Promise<GenericResponse<LambdaGraphSummariesResponse[]>> {
		const url = 'app/ai/graph-summary';

		return axiosConfig.instance.post(url, request).then((res) => {
			return res.data as GenericResponse<LambdaGraphSummariesResponse[]>;
		});
	}

	public static GetDashboardSummaryInsights(
		request: LambdaDashboardSummaryRequest
	): Promise<GenericResponse<LambdaDashboardSummaryResponse>> {
		const url = 'app/ai/dashboard-summary';

		return axiosConfig.instance.post(url, request).then((res) => {
			return res.data as GenericResponse<LambdaDashboardSummaryResponse>;
		});
	}
}
